/* src/app/master-data/items/item-form/item-form.component.css */
/*# sourceMappingURL=item-form.component-PIY4YGTZ.css.map */
